import React from "react";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { Bell } from "lucide-react";

export default function NotificationsPage() {
  const [rows, setRows] = React.useState([]);
  React.useEffect(() => { (async () => { const { data } = await api.get("/notifications"); setRows(data); })(); }, []);
  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); setRows(rows.map((r) => r.id === id ? { ...r, read: true } : r)); };
  return (
    <div className="space-y-4" data-testid="notifications-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "Manrope, sans-serif" }}>Notifikasi</h1>
        <p className="text-sm text-neutral-500">Notifikasi sistem dan operasional.</p>
      </div>
      <div className="card-flat divide-y divide-neutral-200">
        {rows.map((n) => (
          <div key={n.id} className={`p-4 flex items-start gap-3 ${n.read ? "opacity-60" : ""}`} data-testid={`notif-${n.id}`}>
            <Bell className={`h-4 w-4 mt-0.5 ${n.type === "warning" ? "text-amber-600" : "text-green-600"}`} />
            <div className="flex-1">
              <div className="font-medium text-sm">{n.title}</div>
              <div className="text-xs text-neutral-500 mt-0.5">{n.message}</div>
              <div className="text-[10px] text-neutral-400 mt-1">{formatDateTime(n.created_at)}</div>
            </div>
            {!n.read && <button onClick={() => markRead(n.id)} className="text-xs text-green-700 hover:underline" data-testid={`mark-read-${n.id}`}>Tandai dibaca</button>}
          </div>
        ))}
        {rows.length === 0 && <div className="text-center py-10 text-sm text-neutral-500">Tidak ada notifikasi.</div>}
      </div>
    </div>
  );
}
